import {
  FETCH_TRANSACTION_HISTORY_REQUEST,
  FETCH_TRANSACTION_HISTORY_SUCCESS,
  FETCH_TRANSACTION_WIN_HISTORY_SUCCESS,
  FETCH_TRANSACTION_LOSE_HISTORY_SUCCESS,
  FETCH_TRANSACTION_DEPOSIT_HISTORY_SUCCESS,
  FETCH_TRANSACTION_WITHDRAW_HISTORY_SUCCESS,
  FETCH_TRANSACTION_HISTORY_FAILURE,
  RESET_TRANSACTION_HISTORY_STATE,
} from '../../types/transaction';

const TransactionHistoryReducer = (
  state = {
    data: null,
    winData: null,
    loseData: null,
    depositData: null,
    withdrawData: null,
    error: null,
    isLoading: false,
  },
  action
) => {
  switch (action.type) {
    case FETCH_TRANSACTION_HISTORY_REQUEST:
      return {
        ...state,
        isLoading: true,
      };
    case FETCH_TRANSACTION_HISTORY_SUCCESS:
      return {
        ...state,
        isLoading: false,
        data: action.data.data,
        error: null,
      };
    case FETCH_TRANSACTION_WIN_HISTORY_SUCCESS:
      return {
        ...state,
        isLoading: false,
        winData: action.data.data,
        error: null,
      };
    case FETCH_TRANSACTION_LOSE_HISTORY_SUCCESS:
      return {
        ...state,
        isLoading: false,
        loseData: action.data.data,
        error: null,
      };
    case FETCH_TRANSACTION_DEPOSIT_HISTORY_SUCCESS:
      return {
        ...state,
        isLoading: false,
        depositData: action.data.data,
        error: null,
      };
    case FETCH_TRANSACTION_WITHDRAW_HISTORY_SUCCESS:
      return {
        ...state,
        isLoading: false,
        withdrawData: action.data.data,
        error: null,
      };
    case FETCH_TRANSACTION_HISTORY_FAILURE:
      return {
        ...state,
        isLoading: false,
        error: action.error,
      };
    case RESET_TRANSACTION_HISTORY_STATE:
      return {
        ...state,
        data: null,
        winData: null,
        loseData: null,
        depositData: null,
        withdrawData: null,
        error: null,
      };
    default:
      return state;
  }
};

export default TransactionHistoryReducer;
